document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('deferred-media');

  wrappers.forEach(wrapper => {
    const btn = wrapper.querySelector('.js-load-media');
    if (!btn) return;

    let isBusy = false; // empêche clics pendant 300ms

    // Initialise la video une seule fois et attache les listeners qui tiennent l'état
    function initVideoIfNeeded() {
      if (wrapper._videoInited) return wrapper._videoEl || null;
      wrapper._videoInited = true;

      // Injecte depuis template si nécessaire (Shopify compat)
      if (!wrapper.querySelector('video')) {
        wrapper.loadTrigger = 'click';
        const template = wrapper.querySelector('template');
        if (template && template.content.firstElementChild) {
          wrapper.appendChild(template.content.firstElementChild.cloneNode(true));
        }
      }

      const video = wrapper.querySelector('video');
      if (!video) return null;
      wrapper._videoEl = video;

      // Handlers pour maintenir un flag fiable
      const markPlaying = () => {
        wrapper._isPlaying = true;
        wrapper.classList.add('video-section--played');
        wrapper.classList.remove('video-section--paused');
      };
      const markPaused = () => {
        wrapper._isPlaying = false;
        wrapper.classList.add('video-section--paused');
        wrapper.classList.remove('video-section--played');

        // Ajout : reset à 0 après 300ms et blocage du bouton
        isBusy = true;
        setTimeout(() => {
          try { video.currentTime = 0; } catch (e) { /* ignore */ }
          isBusy = false;
        }, 300);
      };
      const onEnded = () => {
        wrapper._isPlaying = false;
        wrapper.classList.add('video-section--paused');
        wrapper.classList.remove('video-section--played');
        try { video.currentTime = 0; } catch (e) { /* ignore */ }
      };

      video.addEventListener('play', markPlaying);
      video.addEventListener('playing', markPlaying); // plus fiable pour lecture effective
      video.addEventListener('pause', markPaused);
      video.addEventListener('ended', onEnded);

      // Etat initial
      wrapper._isPlaying = (!video.paused && !video.ended && video.currentTime > 0)
        || (typeof video.webkitDecodedFrameCount !== 'undefined' && video.webkitDecodedFrameCount > 0);

      if (wrapper._isPlaying) {
        wrapper.classList.add('video-section--played');
        wrapper.classList.remove('video-section--paused');
      } else {
        wrapper.classList.remove('video-section--played');
      }

      // Fallback check après init
      setTimeout(() => {
        if (!wrapper._isPlaying && !video.paused && !video.ended) {
          wrapper._isPlaying = true;
          wrapper.classList.add('video-section--played');
          wrapper.classList.remove('video-section--paused');
        }
      }, 50);

      return video;
    }

    // Toggle au click
    btn.addEventListener('click', async () => {
      if (isBusy) return; // blocage si reset en cours

      const video = initVideoIfNeeded();
      if (!video) {
        console.warn('Aucune <video> trouvée dans le wrapper'); return;
      }

      console.debug('Avant toggle', {
        paused: video.paused, currentTime: video.currentTime, readyState: video.readyState, flag: wrapper._isPlaying
      });

      if (wrapper._isPlaying) {
        // pause ; markPaused gère le reset + blocage
        video.pause();
      } else {
        // play
        try {
          const playPromise = video.play();
          if (playPromise !== undefined) await playPromise;
        } catch (err) {
          console.warn('video.play() rejetée :', err);
        }

        // attend 'playing' ou timeout
        const played = await new Promise(resolve => {
          if (!video.paused && !video.ended) return resolve(true);
          const t = setTimeout(() => resolve(!video.paused && !video.ended), 300);
          const onPlaying = () => { clearTimeout(t); video.removeEventListener('playing', onPlaying); resolve(true); };
          video.addEventListener('playing', onPlaying);
        });

        if (played) {
          wrapper._isPlaying = true;
          wrapper.classList.add('video-section--played');
          wrapper.classList.remove('video-section--paused');
        }
      }

      console.debug('Après toggle', {
        paused: video.paused, currentTime: video.currentTime, readyState: video.readyState, flag: wrapper._isPlaying
      });
    });
  });
});